var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import OutputViewer from './outputViewer';
import { defaultPostProcessingConfig } from './helpers/postProcessingHelper';
import { defaultBackgroundConfig, } from './helpers/backgroundHelper';
import useBodyPix from './hooks/useBodyPix';
import useTFLite from './hooks/useTFLite';
import { defaultSegmentationConfig, } from './helpers/segmentationHelper';
const VirtualBackground = ({ sourcePlayback, backgroundConfig, id, onCanvasRef, }) => {
    _react_refresh_temp_2();
    const [segmentationConfig, setSegmentationConfig] = useState(defaultSegmentationConfig);
    const bodyPix = useBodyPix();
    const { tflite, isSIMDSupported } = useTFLite(segmentationConfig);
    useEffect(() => {
        if (bodyPix) {
            setSegmentationConfig((previousSegmentationConfig) => {
                if (previousSegmentationConfig.backend === 'wasmSimd' &&
                    !isSIMDSupported) {
                    return { ...previousSegmentationConfig, backend: 'wasm' };
                }
                else {
                    return previousSegmentationConfig;
                }
            });
        }
    }, [isSIMDSupported]);
    return (_jsx(_Fragment, { children: sourcePlayback && bodyPix && tflite ? (_jsx(OutputViewer, { sourcePlayback: sourcePlayback, backgroundConfig: backgroundConfig !== null && backgroundConfig !== void 0 ? backgroundConfig : defaultBackgroundConfig, segmentationConfig: segmentationConfig, postProcessingConfig: defaultPostProcessingConfig, bodyPix: bodyPix, tflite: tflite, id: id, onCanvasRef: onCanvasRef })) : null }));
};
_react_refresh_temp_1 = VirtualBackground;
$RefreshReg$(_react_refresh_temp_1, "VirtualBackground");
_react_refresh_temp_2(VirtualBackground, "TixiMT0+xn1vI+y8Tp+0ZvCJ9ic=", false, () => [useBodyPix, useTFLite]);
export default VirtualBackground;
